import {createFileRoute} from '@tanstack/react-router'
import EmbedLeagueWidget from '../../embed/EmbedLeagueWidget'
import services from '../../services'
import {config} from '../../config/config'
import {humanizeSlug} from '../../utilities'

// Public, chrome-less league standings widget for embedding on an organizer's own website.
export const Route = createFileRoute('/embed/leagues/$uid')({
    component: EmbedLeagueWidget,
    validateSearch: (search: Record<string, unknown>): {show?: string; theme?: 'light' | 'dark'} => ({
        show:  typeof search.show === 'string' ? search.show : undefined,
        theme: search.theme === 'dark' ? 'dark' : 'light',
    }),
    loader: async ({params}) => {
        try {
            const l = await services.leagues.find(params.uid)
            return {event: l && (l as any).uid ? l : null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.uid)
        return {
            meta: [
                {title: `${name} | ScorePal`},
                {name: 'robots', content: 'noindex'},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/leagues/${e?.slug || params.uid}/`}],
        }
    },
})
